import _objectSpread from '@babel/runtime/helpers/objectSpread2';
import _objectWithoutProperties from '@babel/runtime/helpers/objectWithoutProperties';
import _PropTypes from 'prop-types';
import * as React from 'react';
import styled from 'styled-components';
import { useTranslations } from '../../hooks/use_translations.js';
import { spacing1x, spacing4x } from '../../styles/spacing.js';
import { useThemeContext } from '../../styles/themes/themes.js';
import { Button } from '../Button/Button.js';
import { Tooltip } from '../Tooltip/Tooltip.js';
import { jsx } from 'react/jsx-runtime';

var _excluded = ["as", "hideLabel", "label", "wrapperRef"];
var ActionToolbarItemWrapper = styled.span.withConfig({
  displayName: "ActionToolbarItem__ActionToolbarItemWrapper",
  componentId: "sc-14mu0j2-0"
})(["&&{}"]);
var ActionToolbarItemButton = styled(Button).withConfig({
  displayName: "ActionToolbarItem__ActionToolbarItemButton",
  componentId: "sc-14mu0j2-1"
})(["&&{color:", ";padding:", ";margin-right:", ";min-height:initial;min-width:initial;vertical-align:top;}&&:hover,&&:focus{color:", ";background:", ";}"], function (p) {
  return p.theme.neutralColors.white;
}, spacing1x, spacing4x, function (p) {
  return p.theme.neutralColors.white;
}, function (p) {
  return p.theme.neutralColors.smoke;
});
var ActionToolbarItem = /*#__PURE__*/React.forwardRef(function ActionToolbarItem2(props, ref) {
  var _useThemeContext = useThemeContext(),
      localization = _useThemeContext.localization;

  var _useTranslations = useTranslations(localization === null || localization === void 0 ? void 0 : localization.translations),
      t = _useTranslations.t;

  var _props$as = props.as,
      ActionItem = _props$as === void 0 ? ActionToolbarItemButton : _props$as,
      _props$hideLabel = props.hideLabel,
      hideLabel = _props$hideLabel === void 0 ? true : _props$hideLabel,
      _props$label = props.label,
      label = _props$label === void 0 ? t("ActionToolbar.itemButton") : _props$label,
      wrapperRef = props.wrapperRef,
      rest = _objectWithoutProperties(props, _excluded);

  return /*#__PURE__*/jsx(ActionToolbarItemWrapper, {
    ref: wrapperRef,
    children: /*#__PURE__*/jsx(Tooltip, {
      content: !hideLabel ? void 0 : label,
      variant: "light",
      children: /*#__PURE__*/jsx(ActionItem, _objectSpread({
        variant: ActionItem === ActionToolbarItemButton ? "ghost" : void 0,
        hideLabel: hideLabel,
        label: label,
        ref: ref
      }, rest))
    })
  });
});
ActionToolbarItem.propTypes = {
  "as": _PropTypes.oneOfType([_PropTypes.string, _PropTypes.func, _PropTypes.object]),
  "hideLabel": _PropTypes.bool,
  "label": _PropTypes.string,
  "wrapperRef": _PropTypes.any
};
ActionToolbarItem.displayName = "ActionToolbarItem";

export { ActionToolbarItem, ActionToolbarItemWrapper };
